<template>
  <div class="content">
    <div class="tip" v-if="!adminShow">
      <p class="el-icon-info"><i>{{ $t('app.commission.tip') }}</i></p>
    </div>
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId" v-show="adminShow">
        <el-select v-model="queryParams.userId" filterable :placeholder="$t('app.commission.agent')" @change="agentsearch" clearable >
          <el-option v-for="(item,index) in agent" :key="index" :label="'['+item.username+']-'+item.company" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="targetUserId">
        <el-select v-model="queryParams.targetUserId" filterable :placeholder="$t('app.commission.subAgent')" @change="search" clearable>
          <el-option v-for="(item,index) in agentList" :key="index" :label="'['+item.username+']-'+item.company" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="iccid">
        <el-input v-model="queryParams.iccid" clearable :placeholder="placeholderICCID"  @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item  prop="orderNum" >
        <el-input v-model="queryParams.orderNum" clearable :placeholder="placeholderOrderNum"  @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item  prop="levels" v-if="adminShow">
        <el-select style="width: 130px;" v-model="queryParams.levels" clearable  multiple :placeholder="$t('app.commission.agentLevel')"   >
          <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          :start-placeholder="$t('app.common.startDate')"
          :end-placeholder="$t('app.common.endDate')"
        ></el-date-picker>
      </el-form-item>
      <el-form-item  prop="status">
          <el-select v-model="queryParams.status" filterable :placeholder="$t('app.commission.status')" @change="search" clearable>
            <el-option :label="$t('app.commission.statusPaid')" value="1"></el-option>
            <el-option :label="$t('app.commission.statusCleared')" value="0"></el-option>
          </el-select>
        </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">{{ $t('app.common.search') }}</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">{{ $t('app.common.reset') }}</el-button>
        <el-button type="primary" icon="el-icon-download" @click="handleExport" v-hasPermi="['order:commission:export']">{{ $t('app.common.export') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border id="out-table"  v-loading="loading">
      <el-table-column type="index" :label="$t('app.common.serialNumber')" align="center" width="60px"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center" width="185px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div>{{ scope.row.iccid }}</div>
          <template v-if="scope.row.operationName == '多网'">
            <div class="sub-iccid" v-if="scope.row.ydIccid">{{ scope.row.ydIccid }}</div>
            <div class="sub-iccid" v-if="scope.row.dxIccid">{{ scope.row.dxIccid }}</div>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="companyName" :label="$t('app.commission.table.agent')" align="center" min-width="260" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="subCompanyName" :label="$t('app.commission.table.subAgent')" align="center" min-width="260" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="orderNum" :label="$t('app.commission.table.orderNum')" align="center" width="225px"></el-table-column>
      <el-table-column prop="createTime" :label="$t('app.common.createTime')" align="center" width="180px"></el-table-column>
      <el-table-column prop="realPayAmount" :label="$t('app.commission.table.payAmount')" align="center"></el-table-column>
      <el-table-column prop="totalRebateAmount" :label="$t('app.commission.table.totalRebate')" align="center"></el-table-column>
      <el-table-column prop="realRebateAmount" :label="$t('app.commission.table.actualRebate')" align="center"></el-table-column>
      <el-table-column prop="subRealRebateAmount" :label="$t('app.commission.table.subRebate')" align="center"></el-table-column>
      <template v-if="checkPermi(['product:add:price'])">
        <el-table-column prop="rate" :label="$t('app.commission.table.rate')" align="center"></el-table-column>
        <el-table-column prop="baseOrderAmount" :label="$t('app.commission.table.baseAmount')" align="center"></el-table-column>
        <el-table-column prop="orderRebateAmount" :label="$t('app.commission.table.rateRebateAmount')" min-width="120"  align="center"></el-table-column>
        <el-table-column prop="extraAmount" :label="$t('app.commission.table.extraAmount')" align="center"></el-table-column>
        <el-table-column prop="realExtraAmount" :label="$t('app.commission.table.realExtraAmount')" min-width="120" align="center"></el-table-column>
        <el-table-column prop="extraRate" :label="$t('app.commission.table.extraRate')" min-width="120" align="center"></el-table-column>
      </template>
      <el-table-column prop="status" :label="$t('app.commission.status')" align="center">
        <template slot-scope="{row}">
          <el-tag v-if="row.status == '1'">{{ $t('app.commission.statusPaid') }}</el-tag>
          <el-tag v-else type="danger">{{ $t('app.commission.statusCleared') }}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="queryInfo"
    />
  </div>
</template>
<script>
import { commission ,commissionExport} from "@/api/api.js"; //佣金列表
import { agentList } from "@/api/api.js"; //佣金列表
import { agentChildList } from "@/api/api.js"; 
import { selectMultiNetCard } from "@/api/multiNet.js"; //根据组网号查询多网卡号
export default {
  name: "commission",
  data() {
    return {
      // 遮罩层
      loading: true,
      placeholderICCID:"ICCID",
      placeholderOrderNum:"订单号",
      queryParams: {
        userId: "",
        orderNum: "",
        iccid: "",
        levels:["1"]
      },
      tableData: [],
      dateRange: [],
      page: 1,
      pageSize: 20,
      total: 0,
      agent:[],
      agentList:[],
      // 代理商层级
      levelList: [
        { value: "1", label: "层级1级" },
        { value: "2", label: "层级2级" },
        { value: "3", label: "层级3级" },
        { value: "4", label: "层级4级" },
        { value: "5", label: "层级5级" },
        { value: "6", label: "层级6级" }
      ],
    };
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  methods: {
    queryInfo() {
      let params = {
        model:{
          ... this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      this.loading = true;
      commission(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
        this.loading = false;
      });
    },
    // 多网订单：根据组网号查询移动/电信卡号
    loadMultiNetCard(row) {
      selectMultiNetCard({ groupNo: row.iccid }).then(res => {
        let data = res.data.data || {};
        // 使用 $set 确保新增属性为响应式，触发视图更新
        this.$set(row, 'ydIccid', data.ydIccid || "");
        this.$set(row, 'dxIccid', data.dxIccid || "");
      });
    },
    // 导出
    handleExport() {
      let params = {
        model:{
          ... this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      // 搜索日期
      this.$alert( this.$t('app.commission.export.confirm'), this.$t('app.commission.export.title'), {
        confirmButtonText: this.$t('app.common.confirm')
      }).then(() => {
        if(this.tableData.length == 0){
          return this.$message.error(this.$t('app.commission.export.noData'));
        }else{
          commissionExport(params).then(res => {
            this.$notify({
                title: this.$t('app.common.success'),
                message: this.$t('app.commission.export.success'),
                type: "success",
                offset:30
              });
          });
        }
      }).catch(() => {});
    },
    // 搜索
    search() {
      this.page = 1,
      this.queryInfo();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.dateRange = [];
      this.queryParams={
        userId: "",
        orderNum: "",
        iccid: "",
      };
      if(this.adminShow){
        this.queryParams.levels=["1"]
      }
      this.search();
      this.queryAgentList()
    },
    queryAgentList() {
      agentList().then(res => {
        this.agent = res.data.data;
        this.agentList = res.data.data;
      });
    },
    agentsearch(){
      if(!this.queryParams.userId){
        this.queryAgentList()
        return 
      }
      let params ={
        userId:this.queryParams.userId
      }
      agentChildList(params).then(res => {
        this.agentList = res.data.data;
      })
    },
  },
  watch: {
    $route: {
      handler: function(to, from){
        if(to.name == 'commission'){
          this.queryInfo();
        }
      },
      deep: true
    }
  },
  created() {
    if(this.adminShow){
      this.placeholderICCID=this.$t('app.commission.iccidAdmin');
      this.placeholderOrderNum=this.$t('app.commission.orderNumAdmin');
      let currentDate = new Date();
      currentDate.setFullYear( currentDate.getFullYear() - 1);
      this.dateRange =[currentDate.toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)];
    }else{
      this.placeholderICCID="ICCID/CID";
      this.placeholderOrderNum=this.$t('app.commission.orderNum');
      this.queryParams={};
    }
    this.queryInfo();
    this.queryAgentList();
  }
};
</script>
<style scoped lang="less">

.content{
  .tip{
    padding: 0px 7px;
    background-color: #ecf8ff;
    border-radius: 4px;
    border-left: 5px solid #50bfff;
    margin: 8px 0;
    margin-top: -12px;
    p{
      font-size: 14px;
      color: #5e6d82;
      line-height: 1.5em;
      i{
          font-style: italic;
      }
    }

  }
  // 多网卡号副行样式：灰色小字
  .sub-iccid{
    font-size: 12px;
    color: #909399;
    line-height: 1.5em;
    word-break: break-all;
  }

}
</style>

